

    <div class="container">
      <div class="tile is-ancestor">
        <div class="tile is-vertical is-8">
          <div class="tile">
            <div class="tile is-parent is-vertical ">
              <article class="tile is-child  box is-primary">
                <p class="title">Müşteri adı</p>
                <p class="subtitle">Müşteri bilgileri</p>
              </article>
              <article class="tile is-child  box is-primary">
                <!-- <p class="title">Ürün bilgileri</p> -->
                <app-cart-search></app-cart-search>

              </article>
  
  
            </div>
            
          </div>
          <div class="tile is-parent">
            <div class="tile is-child box">
              <!-- <p class="subtitle">Sepet bilgileri</p> -->
              <!-- <app-test></app-test> -->
              <app-cart-list></app-cart-list>
            </div>

          </div>

        </div>
        <div class="tile is-parent is-4">
          <article class="tile is-child  is-success box">
            <div class="content">

                <app-payment></app-payment>
 
            </div>
          </article>
        </div>

      </div>
      <div class="tile is-vertical is-12">
        <article class="tile is-child  box is-primary">
          burası boş olacak
        </article>
      </div>
    </div>
 